module.exports = __webpack_public_path__ + "static/media/grin-beam-sweat.b99a1c53.svg";